// Copyright (C) Siemens AG 2026. All rights reserved. Confidential

import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store'
import { announcementStateReducer, authUserStateReducer, availableNeoSimitVersionsReducer,  currentTenantDataStateReducer, identityStateReducer
} from 'src/app/app-states/reducers/app.reducers';
import { AuthPortalUser, TenantUser } from '../model/platformuser.model';
import { ProjectExternal } from '../model/project.external';
import { SubTenant } from '../model/subtenant';
import { PricingPlan } from '../model/pricingplan';
import { Announcement, AnnouncementImage } from '../model/announcement.model';



export interface AuthPortalUserState {
    authUser: AuthPortalUser | null;
    error: boolean;
    status: 'not-loaded' | 'loading' | 'loaded';
    currentTenantId: null | number;
}

export interface AvailableNeoSimitVersionsState {
    versions: string[];
    status: null | 'loading' | 'loaded';
    error: boolean;
}

export interface IdentityState {
    identity: any;
    status: null | 'not-checked' | 'checked';
    error: boolean;
    idToken: string;
}

export interface AnnouncementState {
    announcements: Announcement[];
    status: 'not-loaded' | 'loading' | 'loaded';
    images: {[key: string]: AnnouncementImage};
    error: boolean;
}

export interface CurrentTenantDataState {
    projects: ProjectExternal[];
    projectsStatus: 'not-loaded' | 'loading' | 'loaded';
    users: TenantUser[];
    usersStatus: 'not-loaded' | 'loading' | 'loaded';
    subTenants: SubTenant[];
    subTenantsStatus: 'not-loaded' | 'loading' | 'loaded';
    pricingPlans: PricingPlan[];
    pricingPlansStatus: 'not-loaded' | 'loading' | 'loaded';
    priceList: any | null;
    priceListStatus: 'not-loaded' | 'loading' | 'loaded' | 'error';
}

export interface ApplicationState {
    identityState: IdentityState;
    authPortalUserState: AuthPortalUserState;
    currentTenantDataState: CurrentTenantDataState;
    availableNeoSimitVersionsState: AvailableNeoSimitVersionsState;
    announcementsState: AnnouncementState;
}

export const reducersApplicationState: ActionReducerMap<ApplicationState> = {
    identityState: identityStateReducer,
    authPortalUserState: authUserStateReducer,
    availableNeoSimitVersionsState: availableNeoSimitVersionsReducer,
    currentTenantDataState: currentTenantDataStateReducer,
    announcementsState: announcementStateReducer

}

export const getApplicationStateSelector = createFeatureSelector<ApplicationState>('ApplicationState')

export const authPortalUserState = createSelector(
    getApplicationStateSelector,
    (state) => state.authPortalUserState
);
export const authPortalUser = createSelector(
    getApplicationStateSelector,
    (state) => state.authPortalUserState.authUser
);
export const currentTenantDataState = createSelector(
    getApplicationStateSelector,
    (state) => state.currentTenantDataState
);
export const selectAvailableNeoSimitVersionsState =  createSelector(getApplicationStateSelector, (state: ApplicationState) => state.availableNeoSimitVersionsState);

export const identityState = createSelector(
    getApplicationStateSelector,
    (state) => state.identityState
);

export const announcementState = createSelector(
    getApplicationStateSelector,
    (state) => state.announcementsState
);

export const priceListState = createSelector(
    getApplicationStateSelector,
    (state) => state.currentTenantDataState
);
 